__webpack_require__.p = "/YGOPriceCompiler/";